import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [openItem, setOpenItem] = useState<number | null>(null);

  const faqItems: FAQItem[] = [
    {
      question: "What's the pricing?",
      answer: "$44 a month. No long term contracts."
    },
    {
      question: "Does it integrate with...?",
      answer: "Relatable integrates with Gmail, Google Workspace, Microsoft Office/Exchange, LinkedIn, iMessage, WhatsApp, Apple Contacts, iPhone Calls, Calendar, and Spreadsheets. We have dozens of built-in integrations and you can also use Zapier to connect Relatable to thousands of other applications."
    },
    {
      question: "Are you secure?",
      answer: "Yes, we take security seriously. All data is encrypted in transit and at rest. We use industry-standard security practices to protect your information."
    },
    {
      question: "Is my information private?",
      answer: "Absolutely. Your data is yours. We don't sell, share, or use your information for anything other than providing you with our service. Your privacy is our priority."
    },
    {
      question: "Are you guys going to stick around?",
      answer: "Yes, we are privately held with no pressure to sell. We're building Relatable for the long term and committed to being here for our customers."
    },
    {
      question: "I used to use Contactually and miss it. This sounds similar.",
      answer: "Yes, it's the same team behind it! We have the same methodology behind it, but built with 2025 technology and behavioral insights, not 2011. Relatable is the evolution of what Contactually was trying to achieve."
    },
    {
      question: "Do you have a mobile app?",
      answer: "Yes of course! It's 2025 - we have apps for iPhone, iPad, and Android."
    },
    {
      question: "Can I try it out?",
      answer: "Yes! We offer a 10-day free trial so you can experience how Relatable can transform your relationship management. No credit card required to start."
    }
  ];

  const toggleItem = (index: number) => {
    setOpenItem(openItem === index ? null : index);
  };

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-serif text-5xl font-light leading-tight tracking-tight text-gray-900 mb-12 text-center">
          Frequently Asked Questions
        </h2>
        
        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200"
                onClick={() => toggleItem(index)}
              >
                <h3 className="font-sans text-lg font-medium text-gray-900">
                  {item.question}
                </h3>
                <svg
                  className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                    openItem === index ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {openItem === index && (
                <div className="px-6 pb-4">
                  <p className="font-sans text-base text-gray-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <p className="font-sans text-lg text-gray-600 mb-6">
            Still have questions? We're here to help.
          </p>
          <a 
            href="mailto:hello@relatable.one" 
            className="inline-block bg-purple-600 text-white px-8 py-3 rounded-lg font-medium text-lg transition-all duration-200 hover:bg-purple-700 hover:scale-105"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ; 